import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PluggableMap } from 'ol';
import { Control, Zoom } from 'ol/control';

@Component({
    selector: 'app-zoom',
    templateUrl: './zoom.component.html',
    styleUrls: ['./zoom.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class ZoomComponent implements OnInit, AfterViewInit, OnDestroy {
  private elRef = inject(ElementRef);

  readonly map = input<PluggableMap>(undefined);

  control: Control;

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    let zoomInIcon = document.createElement('i');
    zoomInIcon.className = 'fa fa-plus';

    let zoomOutIcon = document.createElement('i');
    zoomOutIcon.className = 'fa fa-minus';

    this.control = new Zoom(
      {
        target: this.elRef.nativeElement.parentNode,
        className: 'esk-tool',
        zoomInClassName: 'esk-tool-zoom-in',
        zoomOutClassName: 'esk-tool-zoom-out',
        zoomInLabel: zoomInIcon,
        zoomOutLabel: zoomOutIcon
       });

      this.map().addControl(this.control);
  }

  ngOnDestroy(): void {
    if(this.control == null)
    return;

    this.map().removeControl(this.control);
  }
  }

